import * as md5 from 'crypto-js/md5';
import {ConstStatic} from './constStatic';

export const formatDataToUrl = function (data, urlP) {
  if (typeof (data) === 'string') {
    return urlP + '/' + data;
  }
  if (typeof (data) === 'object') {
    let args = '?';
    if (urlP.split('?').length > 1) {
      args = '&';
    }
    let i = 0;
    for (let key in data) {
      i++;
      if (i === Object.keys(data).length) {
        args = args + key + '=' + data[key];
      } else {
        args = args + key + '=' + data[key] + '&';
      }
    }
    return urlP + args;
  }
};

export const getCourseInfo = function () {
  let courseInfo = JSON.parse(sessionStorage.getItem(ConstStatic.COURSE_INFO));
  if (courseInfo) {
    return courseInfo;
  }
  return '';
};
export const getReaserchInfo = function () {
  let reaserchInfo = JSON.parse(localStorage.getItem(ConstStatic.RESEARCH_INFO));
  if (reaserchInfo) {
    return reaserchInfo;
  }
  return '';
};
export const getResearchId = function () {
  let researchId = getLocalStorage(ConstStatic.RESEARCHID);
  if (researchId) {
    return researchId;
  }
  return '';
};
export const getUserInfo = function () {
  let userInfo = getLocalStorage(ConstStatic.USER_INFO);
//   console.log(userInfo);
  if (userInfo) {
    return userInfo;
  }
  return '';
};

export const getAppId = function () {
  let appIds = getUserInfo() ? getUserInfo().x_appIds : '';
  if (appIds) {
    return appIds.split(',')[0];
  } else {
    return 'APPY042';
  }
};

export const getUserPhoto = function () {
  let userPhoto = getUserInfo() ? getUserInfo().x_photo : '';
  if (userPhoto) {
    return userPhoto;
  }
  return '';
};

export const getUserId = function () {
  let userId = getUserInfo() ? getUserInfo().x_userId : '';
  if (userId) {
    return userId;
  }
  return '';
};

export const
    getUserName = function () {
  let userName = getUserInfo() ? getUserInfo().x_realName : '';
  if (userName) {
    return userName;
  }
  return '';
};
export const getToken = function getToken() {
  let token = getLocalStorage(ConstStatic.TOKEN_KEY);
  return token;
};
export const getJti = function () {
  let jti = getUserInfo() ? getUserInfo().jti : '';
  if (jti) {
    return jti;
  }
  return '';
};

export const getLocalStorage = function (item) {
  let data = window.localStorage.getItem(item);
  let obj = JSON.parse(data);
  if (obj && obj.localStorageitem) {
    obj = obj.localStorageitem;
  }
  return obj;
};


export const setLocalStorage = function (itemName, item) {
  let obj;
  if (!item) {
    return;
  }
  if (typeof item === 'object') {
    obj = JSON.stringify(item); //转化为JSON字符串
  } else {
    obj = JSON.stringify({'localStorageitem': item});
  }
  window.localStorage.setItem(itemName, obj);
  return obj;
};

export const removeLocalStorage = function (itemName) {
  localStorage.removeItem(itemName);
};
export const getStudyUrlSign = function(userId,timeStamp){
  let appKey = '2qcadzFRwkJ7QguMRG0';
  let appSecret = '045a6d4a3c0e440fb9787892440d525c';
  return md5(appKey + appSecret + userId + timeStamp, 'hex').toString();
};

export const getSignWithUrl = function (urlp) {
  let appKey = '2ecadzFRwkJ7QguQRG0';
  let appSecret = '045a6d4a3c0c440fb9787891440d525c';
  let timestamp = parseInt(new Date().getTime() / 1000 / 60);
  let sig = md5(appKey + appSecret + timestamp, 'hex').toString();
  let stringSig;
  if (urlp.includes('?')){
    stringSig = '&appKey=' + appKey + '&timestamp=' + timestamp.toString() + '&sig=' + sig;
  } else {
    stringSig = '?appKey=' + appKey + '&timestamp=' + timestamp.toString() + '&sig=' + sig;
  }
  return urlp + stringSig;
};
export const getUrlQuery = function (variable){
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i=0;i<vars.length;i++) {
    let pair = vars[i].split('=');
          if (pair[0] == variable){
            return pair[1];
          }
  }
  return (false);
};

